var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Transition } from '@headlessui/react';
import { useParams } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { availableLanguages } from "../../../../shared/language";
import { Translate } from "../../../I18N";










const sidepanelHeader = (closeSidepanelFunction, title) => /*#__PURE__*/
_jsx("div", { className: "flex p-4 mb-2 text-gray-500" }, void 0, /*#__PURE__*/
_jsx("h1", { className: "text-base font-bold grow" }, void 0, title), /*#__PURE__*/
_jsx("button", {
  type: "button",
  className: "justify-end",
  "data-testid": "close-sidepanel",
  onClick: closeSidepanelFunction }, void 0, /*#__PURE__*/

_jsx("span", { className: "sr-only" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Close")
), /*#__PURE__*/
_jsx(XMarkIcon, { className: "w-6" })
)
);


// eslint-disable-next-line max-statements
const Sidepanel = ({
  children,
  closeSidepanelFunction,
  isOpen = false,
  title,
  withOverlay,
  size = 'medium'
}) => {var _availableLanguages$f;
  const { lang: languageKey } = useParams();

  let transitionRight = '-translate-x-[500px]';
  let transitionLeft = '-translate-x-[-500px]';
  let width = 'md:w-[500px]';

  switch (size) {
    case 'small':
      transitionRight = '-translate-x-[300px]';
      transitionLeft = '-translate-x-[-300px]';
      width = 'md:w-[300px]';
      break;

    case 'large':
      transitionRight = 'md:-translate-x-[768px] lg:-translate-x-1/2';
      transitionLeft = 'md:-translate-x-[-768px] lg:-translate-x-[-50%]';
      width = 'md:w-[768px] lg:w-1/2';
      break;

    default:
      break;
  }

  const isRigthToLeft = (_availableLanguages$f = availableLanguages.find((language) => language.key === languageKey)) === null || _availableLanguages$f === void 0 ? void 0 : _availableLanguages$f.rtl;
  const transition = isRigthToLeft ? transitionRight : transitionLeft;
  const contentClasses = 'flex flex-col h-full overflow-y-auto';

  if (withOverlay) {
    return (/*#__PURE__*/
      _jsx(Transition, { show: isOpen, className: "fixed top-0 left-0 z-10 flex w-full h-full max-h-full" }, void 0, /*#__PURE__*/
      _jsx(Transition.Child, {
        className: "w-full transition-opacity duration-200 ease-in bg-gray-900 md:flex-grow",
        enterFrom: "opacity-0",
        enterTo: "opacity-50",
        leaveTo: "opacity-0",
        onClick: closeSidepanelFunction }
      ), /*#__PURE__*/
      _jsx(Transition.Child, {
        as: "aside",
        className: `w-full h-full top-0 right-0 fixed bg-white border-l-2 transition duration-200 ease-in transform ${width}`,
        enterFrom: transition,
        enterTo: "translate-x-0",
        leaveTo: transition }, void 0, /*#__PURE__*/

      _jsx("div", { className: contentClasses }, void 0,
      sidepanelHeader(closeSidepanelFunction, title),
      children
      )
      )
      ));

  }

  return (/*#__PURE__*/
    _jsx(Transition, {
      show: isOpen,
      as: "aside",
      className: `fixed top-0 right-0 z-10 w-full h-full bg-white border-l-2 shadow-lg transition duration-200 ease-in transform ${width}`,
      enterFrom: transition,
      enterTo: "translate-x-0",
      leaveTo: transition }, void 0, /*#__PURE__*/

    _jsx("div", { className: contentClasses }, void 0,
    sidepanelHeader(closeSidepanelFunction, title),
    children
    )
    ));

};

Sidepanel.Body = ({
  children,
  className = ''



}) => /*#__PURE__*/_jsx("div", { className: `flex-grow p-4 ${className}` }, void 0, children);

Sidepanel.Footer = ({
  children,
  className = ''



}) => /*#__PURE__*/_jsx("div", { className: `bottom-0 left-0 w-full bg-white z-1 ${className}` }, void 0, children);


export { Sidepanel };